/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkPartialPatchDependencyRequestSchema = z.object({
  predecessorIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .nullish(),
  remove: z.boolean(),
  successorIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .nullish(),
  waitDays: z.int().nullish(),
});
